import { colors } from '@anyroad/theme';
import { Ticks } from './Ticks';
import { Ring } from './Ring';
import styled from '@emotion/styled';
import { forwardRef } from 'react';

const Container = styled.div({
  color: colors.primary,
  display: 'inline-block',
  position: 'relative',
});

type SpinnerProps = {
  barsHeight?: number;
  barsTilt?: number;
  barsWidth?: number;
  dataTestId?: string;
  /** The data-testid attribute. */
  height?: number;
  /** The height of the spinner. */
  size?: number;
  type?: 'ring' | 'ticks';
  width?: number;
  /** The width of the spinner. */
};

/**
 * Spinner component.
 *
 * @type {React.FC<SpinnerProps>}
 * @returns {React.ReactElement} The spinner.
 * @example
 * import { Spinner } from './Spinner';
 */
export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  (
    { dataTestId = 'spinner', height = 80, width = 80, type = 'ticks' },
    ref
  ) => {
    const renderSpinner = () => {
      switch (type) {
        case 'ring':
          return <Ring height={height} width={width} />;
        case 'ticks':
          return <Ticks height={height} width={width} />;
        default:
          return <Ticks height={height} width={width} />;
      }
    };

    return (
      <Container
        data-testid={dataTestId}
        ref={ref}
        style={{
          height: `${height}px`,
          width: `${width}px`,
        }}
      >
        {renderSpinner()}
      </Container>
    );
  }
);

Spinner.displayName = 'Spinner';
